// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__15Pq4","head":"ProcedureTableInfo_head__2SyUW"};